<template>
	<div
		v-if="isMobile"
		class="z-maximumPlusUltraMinusOne large-device-hidden fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center bg-black/50 backdrop-blur portrait:hidden"
	>
		<div class="border-3 animate-device-rotate h-12 w-24 rounded-lg border-white" />

		<div class="mt-8 text-xl font-bold text-white">
			Please rotate your device for a better experience.
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const isMobile = computed(() => {
		const match = window.matchMedia
		if (!match) return false
		const device = match('(pointer:coarse)')
		return device.matches
	})
</script>

<style scoped>
	@media screen and (min-height: 640px) {
		.large-device-hidden {
			display: none !important;
		}
	}
</style>
